
// eslint-disable-next-line import/prefer-default-export
export async function retryFn(fn, retries = 3, delay = 1000) {
  const attempt = async (retryCount) => {
    try {
      return await fn();
    } catch (error) {
      if (retryCount <= 0) throw error;
      await new Promise(res => setTimeout(res, delay));
      return attempt(retryCount - 1);
    }
  };

  return attempt(retries);
}



// WEBPACK FOOTER //
// ./src/util/helpers.js